module.exports = __webpack_public_path__ + "static/img/tianmao.f391fbad.png";